/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { DenseMatrixDependencies } from './dependenciesDenseMatrixClass.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createSmaller } from '../../factoriesAny.js';
export var smallerDependencies = {
  DenseMatrixDependencies,
  matrixDependencies,
  typedDependencies,
  createSmaller
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesSmaller.generated.js
// module id = 78
// module chunks = 2